export default "__VITE_ASSET__c11ee878__"